import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.appshell');
import { EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'wiz-component-lookit-appshell',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.appshell/view.scss */
:host {
  display: block;
  height: 100%;
}

.lookit-app-shell {
  min-height: 100%;
  background: var(--lookit-color-background);
  color: var(--lookit-color-text);
}

.lookit-app-shell__frame {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: min(100%, 430px);
  height: 100vh;
  height: 100svh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100svh;
  min-height: 100dvh;
  margin: 0 auto;
  overflow: hidden;
  background: var(--lookit-color-surface);
  border-right: 1px solid var(--lookit-border-subtle);
  border-left: 1px solid var(--lookit-border-subtle);
}

.lookit-app-shell__header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: var(--lookit-space-2);
  padding: calc(var(--lookit-space-4) + var(--lookit-safe-area-top)) calc(var(--lookit-space-5) + var(--lookit-safe-area-right)) var(--lookit-space-3) calc(var(--lookit-space-5) + var(--lookit-safe-area-left));
  background: color-mix(in srgb, var(--lookit-color-surface) 94%, transparent);
}

.lookit-app-shell__brand {
  display: flex;
  min-width: 0;
  min-height: var(--lookit-touch-icon);
  align-items: center;
  justify-content: flex-start;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
}

.lookit-app-shell__brand:focus-visible {
  border-radius: var(--lookit-radius-md);
  outline: 2px solid var(--lookit-color-accent-strong);
  outline-offset: 3px;
}

.lookit-app-shell__title {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.05;
}

.lookit-app-shell__wordmark {
  display: block;
  width: clamp(88px, 23vw, 98px);
  height: 40px;
  flex: 0 0 auto;
  object-fit: contain;
  object-position: left center;
}

.lookit-app-shell__title strong {
  overflow: hidden;
  font-family: var(--lookit-font-family-brand);
  font-size: var(--lookit-font-size-xl);
  font-weight: var(--lookit-font-weight-bold);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lookit-app-shell__title span,
.lookit-app-shell__status {
  margin-top: 3px;
  color: var(--lookit-color-text-muted);
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-bold);
}

.lookit-app-shell__status {
  max-width: 116px;
  margin-top: 0;
  overflow-wrap: anywhere;
  text-align: right;
  line-height: 1.3;
}

.lookit-app-shell__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: var(--lookit-space-2);
}

.lookit-app-shell__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--lookit-space-3) calc(var(--lookit-space-4) + var(--lookit-safe-area-right)) max(var(--lookit-space-6), var(--lookit-space-4) + var(--lookit-safe-area-bottom)) calc(var(--lookit-space-4) + var(--lookit-safe-area-left));
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 480px) {
  .lookit-app-shell__frame {
    box-shadow: var(--lookit-shadow-shell);
  }
}
@media (max-width: 360px) {
  .lookit-app-shell__header {
    padding-right: calc(var(--lookit-space-3) + var(--lookit-safe-area-right));
    padding-left: calc(var(--lookit-space-3) + var(--lookit-safe-area-left));
  }
  .lookit-app-shell__content {
    padding-right: calc(var(--lookit-space-3) + var(--lookit-safe-area-right));
    padding-left: calc(var(--lookit-space-3) + var(--lookit-safe-area-left));
  }
}`],
})
export class ComponentLookitAppshellComponent {
    @Input() title: string = 'Lookit';
    @Input() subtitle: string = '';
    @Input() wordmarkSrc: string = '';
    @Input() wordmarkAlt: string = 'Lookit';
    @Input() status: string = '';
    @Input() maxWidth: string = '430px';
    @Output() brandPressed = new EventEmitter<MouseEvent>();

    public onBrandClick(event: MouseEvent) {
        this.brandPressed.emit(event);
    }
}

export default ComponentLookitAppshellComponent;